import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// import { hasAccess } from '../../../utils/auth'
import { formatCurrency2 } from '../../../utils/currency'
import { transformPercent } from '../../../utils/percent'

import DecimalInput from '../../../shared/components/DecimalInput'

// Elements
// import Grid from '../../../shared/elements/grid'
import Text from '../../../shared/elements/text'
import DropDown from '../../../shared/elements/dropDown'
// import Button from '../../../shared/elements/button'
import Icon from '../../../shared/elements/icon'
import { ElementIcons } from '../../../shared/elements/icons'
import TableRow from '../../../shared/elements/tableRow'
import RemoveButton from '../../../shared/elements/removeButton'
import AddButton from '../../../shared/elements/addButton'

// import styles
import './priceitem.scss'

class PriceItem extends Component {
  constructor (props) {
    super(props)
    this.state = {
      config: {           // Example data - will be overwritten by config used in containing PriceItemGroup
        itemIdField: null,
        draggable: true,
        editable: true,
        itemCss: 'item',
        allowDelete: true,
        fields: [],
        newItemInputs: []
      },
      item: null
    }
    this.renderField = this.renderField.bind(this)
    this.renderAdd = this.renderAdd.bind(this)
    this.stateFromProps = this.stateFromProps.bind(this)
    this.createNewItem = this.createNewItem.bind(this)
    this.getOptionValues = this.getOptionValues.bind(this)
    this.onAdd = this.onAdd.bind(this)
  }

  stateFromProps (props) {
    let state = this.state
    if (props.config !== undefined && props.config !== null) {
      state.config = props.config
    }
    if (state.config.itemIdField !== null) {
      if (props.item === undefined || props.item === null) {
        // Create blank item
        state.item = this.createNewItem(state.config)
      } else {
        state.item = props.item
      }

      let cols = []
      let fields = state.config.fields
      let itemFields = Object.keys(state.item)
      // console.log('Object fields', itemFields, 'fields', fields)
      for (var f = 0; f < fields.length; f++) {
        if (itemFields.findIndex((itemField) => { return itemField === fields[f].name }) !== -1) {
          cols.push(fields[f])
        } else {
          console.error('Field in config not found on item!', fields[f], state.item)
          cols.push({
            name: 'Invalid ' + Math.random(),
            header: 'Invalid',
            type: 'invalid'
          })
        }
      }

      state.cols = cols
      state.itemId = state.item[state.config.itemIdField]
    }
    return state
  }

  componentDidMount () {
    let state = this.stateFromProps(this.props)
    this.setState({...state})
  }

  componentWillReceiveProps (newProps) {
    let state = this.stateFromProps(newProps)
    this.setState({...state})
  }

  createNewItem (config) {
    let newItem = {}
    newItem[config.itemIdField] = 0 // Initialize the item's ID to 0
    if (config.groupField !== undefined && config.groupField !== null && this.props.groupId !== undefined && this.props.groupId !== null) {
      newItem[config.groupField] = this.props.groupId
    }

    for (var f = 0; f < config.fields.length; f++) {
      let field = config.fields[f]
      if (field.name === config.itemIdField) continue
      switch (field.type) {
        case 'currency':
        case 'percent':
        case 'ae':
          newItem[field.name] = 0.0
          break
        case 'int':
          newItem[field.name] = 0
          break
        case 'text':
          newItem[field.name] = ''
          break
        case 'select':
          let option = this.getOptionValues(field)[0]
          let value = Object.keys(option)[0]
          newItem[field.name] = value
          break
      }
    }
    return newItem
  }

  getOptionValues (field) {
    // options can be either an array or a function; if 'options' is a function,
    // it is expected to take field-name as argument and return an array of option values
    let result = [{0: ''}]
    if (field.options === undefined || field.options === null) {
      console.error('Select options not defined for ' + field)
    }
    if (typeof field.options === 'function') {
      result = field.options(field.name)
    } else {
      result = field.options
    }
    return result
  }

  render () {
    if (this.state.config.itemIdField === null) return null
    let hasValidId = this.state.item[this.state.config.itemIdField] !== 0
    let orderLockedField = this.state.config.itemOrderLocked
    let orderLocked = false
    if (orderLockedField !== undefined && orderLockedField !== null && this.state.item[orderLockedField] !== undefined) {
      orderLocked = this.state.item[orderLockedField]
    }
    let dragColumn = null
    if (this.state.config.draggable && this.state.config.editable) {
      dragColumn = (
        <div className='dragcolumn' />
      )
      if (hasValidId && !orderLocked) {
        dragColumn = (
          <div className='dragcolumn'>
            <Icon icon={ElementIcons.Drag_Icon} imgClassName='dragIcon handle' />
          </div>
        )
      }
    }

    const shouldRenderDelete = hasValidId && this.state.config.editable && this.state.config.allowDelete && this.props.onDelete !== undefined && this.props.onDelete !== null
    const shouldRenderAddage = !hasValidId && this.state.config.editable && this.state.config.allowAdd && this.props.onAdd !== undefined && this.props.onAdd !== null

    const cols = this.props.generateColWidths(this.state.config.fields, dragColumn, (shouldRenderDelete || shouldRenderAddage))

    let itemCss = 'priceitem' // 'clearfix form priceitem'
    if (!hasValidId) itemCss += ' priceitem_static priceitem_noid'
    if (orderLocked) itemCss += ' priceitem_nomove'
    // if (this.state.config.itemCss !== undefined && this.state.config.itemCss !== null) itemCss += (' ' + this.state.config.itemCss)
    itemCss += this.props.itemClass ? ' ' + this.props.itemClass : ''

    return (
      <li className={itemCss} data-index={this.props.index}>
        <TableRow cols={cols}>
          {dragColumn}
          {this.state.cols !== undefined && this.state.cols.map(this.renderField)}
          {shouldRenderDelete && this.renderDelete()}
          {shouldRenderAddage && this.renderAdd()}
        </TableRow>
      </li>
    )
    // return (
    //   <li className={itemCss} data-index={this.props.index}>
    //     <Grid cols={cols} align='center'>
    //       {dragColumn}
    //       {this.state.cols !== undefined && this.state.cols.map(this.renderField)}
    //       {shouldRenderDelete && this.renderDelete()}
    //       {shouldRenderAddage && this.renderAdd()}
    //     </Grid>
    //   </li>
    // )
  }

  renderField (val, key) {
    if (val.hide) return null
    let value = this.state.item[val.name]
    let name = val.name
    let type = val.type
    let css = val.css
    let isNewItem = (this.state.itemId === null || this.state.itemId === 0) && this.state.config.newItemInputs.findIndex((s) => { return s.toLowerCase() === val.name.toLowerCase() }) !== -1
    let editable = (isNewItem || (this.state.itemId > 0 && val.editable)) && this.state.config.editable
    let renderKey = this.state.config.itemIdField + '_' + this.state.itemId + '_' + name
    const size = 's'

    const decimalOnBlur = (data) => {
      if (data.value !== value) {
        updateItem(data.value, data.shouldAdd)
      }
    }

    const textOnBlur = (e) => {
      if (value !== e.target.value) {
        updateItem(e.target.value)
      }
    }

    const textOnKeyPress = (e) => {
      if ((e.key === 'Enter' || e.key === 'Tab') && e.target.value) {
        updateItem(e.target.value, true)
      }
    }

    const onChange = (e) => {
      if (value !== e.target.value) {
        let item = this.state.item
        item[name] = e.target.value
        this.setState({
          item: item
        })
      }
    }

    const updateItem = (value, shouldAdd = false) => {
      let item = this.state.item
      item[name] = value
      this.setState({
        item: item
      }, () => {
        if (!isNewItem) {
          this.props.onUpdate(this.state.item)
        }
        const { newItemInputs } = this.state.config
        const isLast = newItemInputs[newItemInputs.length - 1].toLowerCase() === val.name.toLowerCase()
        if (shouldAdd && isNewItem && isLast) {
          this.onAdd()
        }
      })
    }

    const renderText = () => {
      if (editable) {
        return (
          <Text
            value={value}
            onChange={onChange}
            onBlur={textOnBlur}
            onKeyDown={textOnKeyPress}
            disabled={this.props.disabled}
            size={size}
            key={renderKey}
            maxLength={50}
          />
        )
      }

      return <div key={renderKey} className={css}>{value}</div>
    }

    const renderCurrency = () => {
      const transformValue = (value, toClean) => {
        if (type === 'percent') {
          return transformPercent(value, toClean)
        }
        return value
      }

      if (editable) {
        return (
          <DecimalInput
            value={value}
            decimals={2}
            name={name}
            onBlur={decimalOnBlur}
            disabled={this.props.disabled}
            transformValue={transformValue}
            size={size}
            key={renderKey}
          />
        )
      }

      if (this.state.itemId > 0) {
        return <div key={renderKey} className={css}>{transformValue(formatCurrency2(value, 2))}</div>
      }

      return <div key={renderKey} className={css} />
    }

    const renderAE = () => {
      if (editable) {
        return (
          <DecimalInput
            value={value}
            decimals={5}
            name={name}
            onBlur={decimalOnBlur}
            disabled={this.props.disabled}
            size={size}
            key={renderKey}
          />
        )
      }

      if (this.state.itemId > 0) {
        return <div key={renderKey} className={css}>{formatCurrency2(value, 5)}</div>
      }

      return <div key={renderKey} className={css} />
    }

    const renderInt = () => {
      if (editable) {
        return (
          <DecimalInput
            value={value}
            decimals={0}
            name={name}
            onBlur={decimalOnBlur}
            disabled={this.props.disabled}
            size={size}
            key={renderKey}
          />
        )
      }

      if (this.state.itemId > 0) {
        return <div key={renderKey} className={css}>{formatCurrency2(value, 0)}</div>
      }

      return <div key={renderKey} className={css} />
    }

    const renderSelect = () => {
      let options = this.getOptionValues(val)

      if (editable) {
        return (
          <DropDown onChange={onChange} size={size} key={renderKey}>
            {options.map((v, k) => {
              let value = Object.keys(v)[0]
              let display = v[value]
              return <option key={renderKey + '_' + k} value={value}>{display}</option>
            }
            )}
          </DropDown>
        )
      }

      if (this.state.itemId > 0) {
        return <div key={renderKey} className={css}>{value}</div>
      }

      return <div key={renderKey} className={css} />
    }

    const renderInvalid = () => {
      return <div key={renderKey} className='invalid'>INVALID</div>
    }

    switch (type) {
      case 'text':
        return renderText()
      case 'percent':
      case 'currency':
        return renderCurrency()
      case 'ae':
        return renderAE()
      case 'int':
        return renderInt()
      case 'select':
        return renderSelect()
      case 'invalid':
        return renderInvalid()
    }
    return (
      <div key={renderKey} className={css}>&nbsp;</div>
    )
  }

  renderDelete () {
    let renderKey = this.state.config.itemIdField + '_' + this.state.itemId + '_delete'

    return (
      <RemoveButton
        onClick={() => this.props.onDelete(this.state.item)}
        disabled={this.props.disabled}
        size='s'
        key={renderKey}
      />
    )
  }

  renderAdd () {
    // const onAdd = () => {
    //   this.props.onAdd(this.state.item)
    //   this.setState({
    //     item: this.createNewItem(this.state.config)
    //   })
    // }
    let renderKey = this.state.config.itemIdField + '_' + this.state.itemId + '_add'

    return (
      <AddButton
        onClick={this.onAdd}
        disabled={this.props.disabled}
        size='s'
        key={renderKey}
      />
    )
  }

  onAdd () {
    this.props.onAdd(this.state.item)
    this.setState({
      item: this.createNewItem(this.state.config)
    })
  }
}

PriceItem.propTypes = {
  auth: PropTypes.object.isRequired
  // item: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
})(PriceItem)



// WEBPACK FOOTER //
// ./src/app/pages/Prices/PriceItem/index.js